<template>
  <scout-form
    :is-modified="value !== null"
    label="現在の就業状況"
    half
  >
    <label
      v-for="(option ,i) in options"
      :key="i"
      class="pega-badge-radio pega-mr-5"
    >
      <input
        :checked="value === option.value"
        :value="option.value"
        :data-test="'option-' + option.value"
        type="radio"
        @change="$emit('input', $event.target._value)"
      >
      <span
        :data-test="'option-name-' + option.value"
        class="pega-badge-radio-text pega-badge-radio-check-mark"
      >{{ option.name }}</span>
    </label>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import * as definition from '@/lib/labelValueMappings'

export default {
  components: {
    ScoutForm
  },
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === 'boolean' || prop === null
    }
  },
  data () {
    return {
      options: [{ value: null, name: '指定なし' }, ...definition.employed]
    }
  }
}
</script>
